import styled from "styled-components";
import { Paragraph2 } from "../../components";
import { DropdownOptionsList, OptionButton } from "../DropdownOptions/styled";
import { colors } from "../../consts";

export const CalendarDropdownInputWrapper = styled.div`
  position: relative;

  > button {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    gap: 12px;

    ${Paragraph2} {
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;

      letter-spacing: 0.1px;
    }
  }
`;

export const IconWrapper = styled.div`
  svg {
    transform: ${(props) => (props?.optionsVisible ? "scale(1, -1)" : "scale(1, 1)")};
  }
`;

export const OptionsList = styled(DropdownOptionsList)`
  max-height: unset;
  margin-top: 4px;

  overflow-y: unset;

  background-color: ${colors.WHITE};
`;

export const Option = styled(OptionButton)`
  padding: 0 4px;

  height: 20px;
  min-height: 20px;
  max-height: 20px;

  width: 100%;

  ${Paragraph2} {
    font-size: 14px;
    line-height: 20px;
  }
`;
